import { Usuario } from './usuario.model';
import { Atendimento } from './atendimento.model';
import { AtendimentoEstratificado } from './atendimento-estratificado.model';
import { Prestador } from './prestador.model';

/**
 * Modelo de classe para representar as guias médicas.
 */
export class GuiaMedica {
    id: number;
    cpfTitular: string;
    beneficiado: string;
    matricula: string;
    estabelecimentoCodigo: number;
    dataAtendimento: Date;
    dataAtualizacao: Date;
    usuario: Usuario;
    prestador: Prestador;
    encaminhado = false;
    finalizado: boolean;
    atendimentos: Atendimento[];
    atendimentosEstratificados: AtendimentoEstratificado[];
    nomeTitular: string;
    valorTotal: number;
    dataNascimentoBeneficiado: Date;
    generoBeneficiado: String;
  }
